// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".custom-file-input[data-v-0d05a5ef] {\n  color: #717986;\n}", ""]);
// Exports
module.exports = exports;
